import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IOtpController } from '../../../../utils/interfaces/controller/otp-controller.interface';
import { IOtpMailResponse } from '@utils/interfaces/response/otp-mail-response.interface';
import { OtpMailRequest } from '../../../../utils/classes/request/otp-mail-request';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '@modules/business-accounts/services/auth/auth.service';
import { OtpValidationRequest } from '@utils/classes/request/otp-validation-request';

@Injectable({
  providedIn: 'root',
})
export class OtpApiService implements IOtpController {
  constructor(private readonly http: HttpClient, private readonly authService: AuthService) {}

  otpMail(otpMailRequest: OtpMailRequest): Observable<IOtpMailResponse> {
    return this.http.post<IOtpMailResponse>(
      `${environment.bffOtpSignature}`,
      otpMailRequest,
      {
        headers: this.authService.buildHeadersOtp({ 'X-application-Id': environment.applicationId }),
      }
    );
  }
  otpValidation(otpValidationRequest: OtpValidationRequest): Observable<void> {
    return this.http.put<void>(
      `${environment.bffOtpValidate}`,
      otpValidationRequest,
      {
        headers: this.authService.buildHeadersOtp({ 'X-application-Id': environment.applicationId }),
      }
    );
  }
}
